var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgA3LightGroup(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33 37.75v-5.73a6.82 6.82 0 00-7-6.78A6.92 6.92 0 0019 32v5.75a13.43 13.43 0 1014 0zM26 59a9.4 9.4 0 01-4.11-17.85l1.11-.59V35h6v5.56l1.11.55A9.4 9.4 0 0126 59zm-2 7h4v9h-4v-9zm15.68-6.34L46 66l-2.83 2.83-6.36-6.36 2.87-2.81zm-27.16-.23l2.83 2.83L9 68.62 6.15 65.8l6.37-6.37zM43 47h9v4h-9v-4zM9 51H0v-4h9v4zm54.72-15.55l6.36 6.36-2.83 2.83-6.35-6.36 2.82-2.83zM76 23v4h-9v-4h9zm-19-9.25V8a6.82 6.82 0 00-7-6.78A6.92 6.92 0 0043 8v5.75a13.43 13.43 0 1014 0zM50 35a9.4 9.4 0 01-4.11-17.85l1.11-.59V11h6v5.56l1.11.55A9.4 9.4 0 0150 35z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/A3_Light_group.a8e9ef67.svg";
export { SvgA3LightGroup as ReactComponent };